import { axiosUtil } from '../../../utils/axios_util'
const LanguageManage = {
  //列表分页查询
  getLanguagePage(data: any) {
    return axiosUtil({
      url: '/ai_record-detail/list',
      method: 'post',
      data,
      params: {
        page: data.page,
        size: data.size,
      },
    })
  },

  //导出
  languageExport(data: any) {
    return axiosUtil({
      url: `/ai_record-detail/export_phone_file`,
      method: 'post',
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' },
      data: data
    })
  },

  //录音文件地址
  languageDetail(data: any) {
    return axiosUtil({
      url: `/ai_record-detail/query_record/callId/${data.mainCallId}`,
      method: 'post',
    })
  }, 

  //话术
  botAllList() {
    return axiosUtil({
      url: '/ai/bot/AllList',
      method: 'post',
    })
  }, 
}


export default LanguageManage
